import React from "react";

const ReportsIcon = ({ fill }) => (
  <svg
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    width="22.5"
    height="22.5"
    viewBox="0 0 22.5 22.5"
  >
    <path
      id="line-chart"
      d="M3.18,22A3.183,3.183,0,0,1,0,18.82V10.656a3.18,3.18,0,1,1,6.359,0V18.82A3.183,3.183,0,0,1,3.18,22Zm0-12.8a1.463,1.463,0,0,0-1.461,1.461V18.82a1.461,1.461,0,0,0,2.922,0V10.656A1.463,1.463,0,0,0,3.18,9.2ZM11,22a3.183,3.183,0,0,1-3.18-3.18V15.3a3.18,3.18,0,0,1,6.359,0V18.82A3.183,3.183,0,0,1,11,22Zm0-8.164A1.463,1.463,0,0,0,9.539,15.3V18.82a1.461,1.461,0,0,0,2.922,0V15.3A1.463,1.463,0,0,0,11,13.836ZM18.82,22a3.183,3.183,0,0,1-3.18-3.18V11.3A3.18,3.18,0,1,1,22,11.3v7.52A3.183,3.183,0,0,1,18.82,22Zm0-12.16A1.463,1.463,0,0,0,17.359,11.3v7.52a1.461,1.461,0,0,0,2.922,0V11.3A1.463,1.463,0,0,0,18.82,9.84ZM14.042,9.5l4.756-5a.859.859,0,0,0-1.245-1.185l-4.764,5-.016.018a1.292,1.292,0,0,1-1.738.164L5.58,3.547l-.045-.038a3,3,0,0,0-3.877.123l-.03.028L.255,5.018A.859.859,0,1,0,1.464,6.24L2.821,4.9a1.286,1.286,0,0,1,1.628-.057L9.9,9.8l.045.038A3.014,3.014,0,0,0,14.042,9.5ZM22,4.9V2.578A2.581,2.581,0,0,0,19.422,0H17.1a.859.859,0,0,0,0,1.719h2.32a.86.86,0,0,1,.859.859V4.9A.859.859,0,0,0,22,4.9Z"
      transform="translate(0.25 0.25)"
      strokeWidth="0.5"
    />
  </svg>
);

export default ReportsIcon;
